import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Get } from "../axios/AxiosFunctions.js";
import { BaseURL } from "../config/apiUrl.js";
import { updateUser } from "../store/auth/authSlice.js";
import {
  setRubric,
  setBundles,
  setUnReadNotificationCount,
} from "store/common/commonSlice.js";
import { roles } from "constant/constants";

export const useGetMe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { isLogin, access_token, user } = useSelector(
    (state) => state.authReducer
  );
  const dispatch = useDispatch();

  const getMe = async () => {
    const meUrl = BaseURL("users/get-me");
    const notificationUrl = BaseURL("notifications/unread-count");
    const rubricUrl = BaseURL("rubrics");
    const subUrl = BaseURL("bundles/find/public");
    setIsLoading(true);
    const [userRes, notificationRes, rubricRes, subRes] =
      await Promise.allSettled([
        Get(meUrl, access_token, false, dispatch),
        Get(notificationUrl, access_token, false, dispatch),
        Get(rubricUrl, access_token, false, dispatch),
        user?.role === roles.SCHOOL_ADMIN
          ? Get(subUrl, access_token, false, dispatch)
          : null,
      ]);
    // Each result stands on its own. Updating the user whenever *any* of the
    // four succeeded wrote `undefined` over it every time get-me was the one
    // that failed, which left the app signed in with no user — every screen
    // reading role, school or campus then rendered nothing.
    if (userRes?.value?.data?.data) {
      dispatch(updateUser(userRes.value.data.data));
    }
    if (notificationRes?.value) {
      dispatch(
        setUnReadNotificationCount(
          notificationRes.value?.data?.data?.unreadCount
        )
      );
    }
    if (rubricRes?.value) {
      dispatch(setRubric(rubricRes.value?.data?.data));
    }
    if (subRes?.value) {
      dispatch(setBundles(subRes.value?.data?.bundles));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!isLogin) return;
    // Small delay so the socket connection has time to write isOnline/socketIds
    // to the DB before get-me reads the user back.
    const timer = setTimeout(() => {
      getMe();
    }, 500);
    return () => clearTimeout(timer);
  }, [isLogin]);
  return isLoading;
};
